import { css } from 'lit'

/**
 * Ligonier-specific base styles that override the generic base styles
 */
export const ligonierBaseStyles = css`
  :host {
    display: block;
    font-family:
      Avenir LT W01_45 Book1475508,
      Avenir,
      sans-serif;
    line-height: 1.8;
    font-weight: 400;
    font-size: 16px;
    color: rgb(16, 11, 0);
  }

  ::selection {
    background: #c8d7d1;
  }

  * {
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family:
      HCo Mercury Text G2,
      Times New Roman,
      serif;
    font-weight: 400;
    line-height: 1.3;
    margin: 0;
  }

  footer {
    background-color: #f7f7f7;
    width: 100%;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  a:hover {
    text-decoration: underline;
    text-underline-offset: 0.25rem;
    color: #859e3b;
  }
`

/**
 * Ligonier font definitions
 */
export const ligonierFonts = css`
  /* Avenir Book - Regular weight */
  @font-face {
    font-family: "Avenir LT W01_45 Book1475508";
    src:
      url("https://fonts.your-cdn.com/AvenirLTW01-45Book1475508.woff2")
        format("woff2"),
      url("https://fonts.your-cdn.com/AvenirLTW01-45Book1475508.woff")
        format("woff");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  /* Avenir Medium - Medium weight */
  @font-face {
    font-family: "AvenirLTW01-65Medium";
    src:
      url("https://fonts.your-cdn.com/AvenirLTW01-65Medium.woff2")
        format("woff2"),
      url("https://fonts.your-cdn.com/AvenirLTW01-65Medium.woff") format("woff");
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  /* Avenir Heavy - Bold weight */
  @font-face {
    font-family: "Avenir LT W01_65 Heavy1475544";
    src:
      url("https://fonts.your-cdn.com/AvenirLTW01-65Heavy1475544.woff2")
        format("woff2"),
      url("https://fonts.your-cdn.com/AvenirLTW01-65Heavy1475544.woff")
        format("woff");
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  /* Mercury Text for headings (alias) */
  @font-face {
    font-family: "HCo Mercury Text G2";
    src:
      url("https://fonts.your-cdn.com/MercuryTextG2-Regular.woff2")
        format("woff2"),
      url("https://fonts.your-cdn.com/MercuryTextG2-Regular.woff")
        format("woff");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
`

/**
 * Ligonier layout styles
 */
export const ligonierLayoutStyles = css`
  /* Layout sections */
  .container {
    max-width: 1024px;
    margin: 0 auto;
    padding: 0 1.25rem;
  }

  .container-sm {
    max-width: 640px;
  }

  /* Divider */
  .divider {
    margin: 2rem auto;
    padding: 0 1.25rem;
  }

  .divider-line {
    border-bottom: 1px solid #e5e7eb;
  }
`

/**
 * Ligonier responsive styles
 */
export const ligonierResponsiveStyles = css`
  /* Responsive design */
  @media (min-width: 768px) {
    .container {
      max-width: 640px;
    }
  }

  @media (min-width: 1024px) {
    .container {
      max-width: 1024px;
    }
  }
`